import { GetTimeFromTimestamp, TravelZone } from '@dave/types';
import {
    SelectSearchOption
} from '../../dave-utils-module/select-search/components/select-search/select-search.component';

export class TravelZoneEntity implements SelectSearchOption{
    constructor(
        public Id: number = null,
        public Name: string = null,
        public Description: string = null,
        public ArlTemplateId: number = null,
        public UpdatedAt: Date = null,
        public DeletedAt: Date = null,
        public PercentAmountFromTravelZone: number = null,
        public Bearbeitungsschluessel: number = null,
        public TravelZoneNumber: number = null,
        public Amount: number = null,
        ) {}
    public static EntityName = 'Fahrtzone';

    public Clone(override: Partial<TravelZoneEntity> = {}): TravelZoneEntity {
        const attr = { ...this, ...override };
        return Object.assign(new TravelZoneEntity(), attr);
    }
    public get DisplayName() {
        return this.Name;
    }
    public get optionLabel() {
        return this.Name;
    }
}

export function TravelZoneEntityFromBackend(res: TravelZone): TravelZoneEntity {
    return new TravelZoneEntity(res.Id && +res.Id, res.Name, res.Description, res.ArlTemplateId && +res.ArlTemplateId, GetTimeFromTimestamp(+res.UpdatedAt), res.DeletedAt && GetTimeFromTimestamp(+res.DeletedAt), res.PercentAmountFromTravelZone && +res.PercentAmountFromTravelZone, res.Bearbeitungsschluessel && +res.Bearbeitungsschluessel, res.TravelZoneNumber && +res.TravelZoneNumber, res.Amount && +res.Amount);
}
